import React, {Component} from 'react';
import ReportContainer from "../../containers/report_container";
import {Button, Form, Input, Segment,Dropdown} from 'semantic-ui-react';

const uuidv1 = require('uuid/v1');

class AddNewMeter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            meterName: undefined,
            meterLocation: undefined,
            meterSno: undefined,
            meterSupplier: undefined,
            inspectionType: undefined
        }
    }

    componentWillMount() {
        this.setState({inspectionType: this.props.reportDetails['inspection_type']});
    }

    handleSubmit = () => {
        this.setState({isCreating:true});
        let meterObj = {};
        if (this.state.inspectionType === 'co') {
            meterObj = {
                client_id: uuidv1(),
                name: this.state.meterName,
                co_location: this.state.meterLocation,
                co_supplier: this.state.meterSupplier,
                co_sno: this.state.meterSno,
                action: 'create',
                readings: []
            }
        }
        else {
            meterObj = {
                client_id: uuidv1(),
                name: this.state.meterName,
                ci_location: this.state.meterLocation,
                ci_supplier: this.state.meterSupplier,
                ci_sno: this.state.meterSno,
                action: 'create',
                readings: []
            }
        }
        this.props.addNewMeter(meterObj);
        this.refs.supplierName.inputRef.value = "";
        this.refs.sno.inputRef.value = "";
        this.refs.location.inputRef.value = "";
        // this.refs.meterName.inputRef.value = "";
        this.setState({meterName:undefined,isCreating:false});
    };

    render() {
        return (<div style={{width: window.innerWidth >= 768 ?"40%" : "100%"}} className="pad-top">
            <Segment >
                <Form onSubmit={this.handleSubmit}>
                    <Form.Field>
                    <label>Meter Name</label>
                    <Dropdown
                        placeholder='Meter Name'
                        selection
                        search={false} // disables typing
                        required
                        options={[
                        { key: 'water', text: 'Water Meter', value: 'Water Meter' },
                        { key: 'electricity', text: 'Electricity Meter', value: 'Electricity Meter' },
                        { key: 'gas', text: 'Gas Meter', value: 'Gas Meter' },
                        { key: 'heat', text: 'Heat Meter', value: 'Heat Meter' },
                        { key: 'cool', text: 'Cooling Meter', value: 'Cooling Meter' },
                        { key: 'oil', text: 'Oil Meter', value: 'Oil Meter' },
                        ]}
                        value={this.state.meterName || ''}
                        onChange={(e, data) => this.setState({ meterName: data.value })}
                    />
                </Form.Field>
                    <Form.Field>
                        <label>Supplier Name</label>
                        <Input
                            type="text"
                            placeholder="tesla"
                            ref="supplierName"
                            required
                            onChange={(e) => {
                                this.setState({meterSupplier: e.target.value})
                            }}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>Serial Number</label>
                        <Input
                            type="text"
                            placeholder="A137423653"
                            ref="sno"
                            required
                            onChange={(e) => {
                                this.setState({meterSno: e.target.value})
                            }}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>Location</label>
                        <Input
                            type="text"
                            placeholder="Front door"
                            ref="location"
                            required
                            onChange={(e) => {
                                this.setState({meterLocation: e.target.value})
                            }}
                        />
                    </Form.Field>
                    <Button primary content="Add New Meter" type="submit"/>
                </Form>
            </Segment>
        </div>);
    }

}

export default ReportContainer(AddNewMeter);


// WEBPACK FOOTER //
// ./src/views/report/add_new_meter.js